export class AccountNyukyokeiyakuViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.nyukyokeiyakuNo = data.nyukyokeiyakuNo;
        this.nyukyokeiyakuName = data.nyukyokeiyakuName;
        this.buknName = data.buknName;
        this.roomNo = data.roomNoHyoji;
    }
    model = null;
    nyukyokeiyakuNo = null;
    nyukyokeiyakuName = "";
    buknName = "";
    roomNo = "";
}
